import React, { useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AppointmentTable from "../components/AppointmentTable";

import { Icon } from "@iconify/react/dist/iconify.js";
import { API_URL } from "..";
import AppointmentStatusTable from "../components/AppointmentStatusTable";
import { useParams } from "react-router-dom";
import { Spinner } from "react-bootstrap";
const AppointmentStatusPage = () => {
    const {status} = useParams();
    const [data,setData]= useState([])
    const [loading, setLoading] = useState(false)
    const fetchAppointments = async () => {
         setLoading(true)
         let headerList = {
           "Accept": "*/*"
        };
        const response = await fetch(
          API_URL+"/api/job/status/"+status,
          { method: "GET", headers: headerList }
        );
        const data = await response.json();
        setLoading(false)
        if (response.status === 200) {
            setData(data.jobs)
        }
      };

      useEffect(()=>{
        fetchAppointments()
      },[1])
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Jobs" />
   
        {/* TableDataLayer */}
        {
          loading === true ?
          <div className="text-center mt-4">
            <Spinner/>
          </div>: null
        }
        {
            data.length == 0 ? null  : 
        <AppointmentStatusTable data={data} />
        }

      </MasterLayout>

    </>
  );
};

export default AppointmentStatusPage; 
